// Locale persistence — single source of truth for both v1 (vanilla JS) and v2 (this React app).
//
// Decision (Session 19A): v1 and v2 share the same localStorage key so a切换
// from either side is reflected in the other on next load. v1 uses the same
// constant via assets/i18n.js (vanilla JS file, mirrored manually).
//
// Why the same key:
// - 主母 may switch lang in v2 today and pick up v1 (still her primary tool until exam).
// - One key avoids the "I changed it but it didn't stick" UX bug.

import { DEFAULT_LOCALE, isLocale, type Locale } from '@examforge/shared/i18n';

export const UI_LANG_STORAGE_KEY = 'examforge.uiLang.v1';

export function readPersistedLocale(): Locale {
  if (typeof window === 'undefined') return DEFAULT_LOCALE;
  try {
    const raw = window.localStorage.getItem(UI_LANG_STORAGE_KEY);
    return isLocale(raw) ? raw : DEFAULT_LOCALE;
  } catch {
    // localStorage may throw in private mode / sandboxed iframes — degrade silently to default.
    return DEFAULT_LOCALE;
  }
}

export function writePersistedLocale(locale: Locale): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(UI_LANG_STORAGE_KEY, locale);
  } catch {
    // Same — silent degrade. The in-memory state still updates.
  }
}
